import { render } from "./DifficultiesForm.vue?vue&type=template&id=4d27b1e8&scoped=true"
import script from "./DifficultiesForm.vue?vue&type=script&lang=js"
export * from "./DifficultiesForm.vue?vue&type=script&lang=js"

import "./DifficultiesForm.vue?vue&type=style&index=0&id=4d27b1e8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d27b1e8"]])

export default __exports__